import { Link } from "react-router-dom";

export default function BatteryNav(props){

    return (
        <>
         <ul className="dc_nav">
                    <li className={`cus-tab ${props.id==1?'active':''}`}><Link to={`/site/${props.site_id}/bms`}>Overview</Link></li>
                    <li className={`cus-tab ${props.id==2?'active':''}`}><Link to={`/site/${props.site_id}/bms/report`}>Report</Link></li>
              </ul>
        </>
    )
}